export const daiCostsClientNotificationMessages = {
  title: 'データを表示できません',
  message:
    '以下のいずれかの理由に該当している可能性があります。\n\n・売上閲覧権限のない店舗が1つ以上存在する\n・設定した検索条件に当てはまる機械台が存在しない',
} as const;
